import styled from 'styled-components';
import FilterRadioButton from './FilterRadioButtons';
import { FilterRadioButtonsContainer } from './FilterRadioButtonsContainer';
import Loader from './Loader';
import NoData from './NoData';

interface WorkplacesButtonsInterface {
  isLoading: boolean;
  doesWorkplacesListExists: boolean;
  apiWorkplaceFetched: boolean;
  handleWorkplaceChange: ({ value, label }: { value: number, label: string }) => void;
  handleTryGetWorkplacesAgain: () => void;
  selectedWorkplace: { value: number, label: string };
  workplaces: { value: number, label: string }[];
  showAllButton: boolean;
}

const Container = styled.div`
  width: 100%;
  position: relative;
  left: 0;
`;

export default function WorkplacesRadioButtons({
  isLoading,
  doesWorkplacesListExists,
  apiWorkplaceFetched,
  handleWorkplaceChange,
  handleTryGetWorkplacesAgain,
  selectedWorkplace,
  workplaces,
  showAllButton = true,
}: WorkplacesButtonsInterface) {
  const isListEmpty = !doesWorkplacesListExists && apiWorkplaceFetched && !isLoading;
  const hasError = !apiWorkplaceFetched && !isLoading;

  return (
    <>
      <Loader isLoading={isLoading} />
      {(!isListEmpty) && (
        <Container>
          <FilterRadioButtonsContainer>
            {showAllButton && (
              <FilterRadioButton
                key={0}
                onClick={() => {
                  handleWorkplaceChange({
                    value: 0,
                    label: 'Todos',
                  });
                }}
                selected={selectedWorkplace.value == 0}
                width="auto"
              >
          Todos
              </FilterRadioButton>
            )}
            {workplaces?.map((workplace) => (
              <FilterRadioButton
                key={workplace.value}
                onClick={() => {
                  handleWorkplaceChange({ value: workplace.value, label: workplace.label });
                }}
                selected={workplace.value == selectedWorkplace.value}
                width="auto"
              >
                {workplace.label}
              </FilterRadioButton>
            ))}
          </FilterRadioButtonsContainer>
        </Container>
      )}

      {isListEmpty && (
        <NoData icon="emptyBox" label={<>Esta empresa não possui locais de trabalho cadastrados. Para existirem dados do sistema de fretamento, a empresa precisa ser previamente configurada para o serviço. </>} />
      )}

      {hasError && (
        <NoData
          icon="sad"
          label={(
            <>
            Ocorreu um erro ao obter os locais de trabalho para exibir o Dashboard.
              <button type="button" onClick={handleTryGetWorkplacesAgain}>Tentar Novamente</button>
            </>
          )}
        />
      )}
    </>
  );
}
